var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0C12.2812 0 13.2773 0.132812 14.2383 0.398438C15.1992 0.664062 16.0938 1.04297 16.9219 1.53516C17.75 2.02734 18.5078 2.61328 19.1953 3.29297C19.8828 3.97266 20.4688 4.73047 20.9531 5.56641C21.4375 6.40234 21.8164 7.30078 22.0898 8.26172C22.3633 9.22266 22.5 10.2188 22.5 11.25C22.5 12.2891 22.3672 13.2852 22.1016 14.2383C21.8359 15.1914 21.457 16.0859 20.9648 16.9219C20.4727 17.7578 19.8867 18.5156 19.207 19.1953C18.5273 19.875 17.7695 20.4609 16.9336 20.9531C16.0977 21.4453 15.1992 21.8242 14.2383 22.0898C13.2773 22.3555 12.2812 22.4922 11.25 22.5C10.2109 22.5 9.21484 22.3672 8.26172 22.1016C7.30859 21.8359 6.41406 21.457 5.57812 20.9648C4.74219 20.4727 3.98438 19.8867 3.30469 19.207C2.625 18.5273 2.03906 17.7695 1.54688 16.9336C1.05469 16.0977 0.675781 15.1992 0.410156 14.2383C0.144531 13.2773 0.0078125 12.2812 0 11.25C0 10.2188 0.132812 9.22266 0.398438 8.26172C0.664062 7.30078 1.04297 6.40625 1.53516 5.57812C2.02734 4.75 2.61328 3.99219 3.29297 3.30469C3.97266 2.61719 4.73047 2.03125 5.56641 1.54688C6.40234 1.0625 7.30078 0.683594 8.26172 0.410156C9.22266 0.136719 10.2188 0 11.25 0ZM18 12V10.5H4.5V12H18Z",
    fill: "#673C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.b5bb9c1c50e9b2ab7b6b8b5bb8f917a1.svg";
export { ForwardRef as ReactComponent };